export const isValidJSON = (str: string): boolean => {
  if (!str || typeof str !== 'string') return false;
  const trimmed = str.trim();
  if (!trimmed.startsWith('{') && !trimmed.startsWith('[')) return false;
  try {
    JSON.parse(trimmed);
    return true;
  } catch {
    return false;
  }
};

export const isXMLLike = (str: string): boolean => {
  if (!str || typeof str !== 'string') return false;
  const trimmed = str.trim();
  return trimmed.startsWith('<') && trimmed.includes('</');
};

export const isHTML = (str: string): boolean => {
  if (!str || typeof str !== 'string') return false;
  const trimmed = str.trim().toLowerCase();
  return (
    (trimmed.startsWith('<!doctype html') ||
      trimmed.startsWith('<html') ||
      trimmed.includes('<body') ||
      trimmed.includes('<head')) &&
    trimmed.includes('</html>')
  );
};

export const isMarkdown = (str: string): boolean => {
  if (!str || typeof str !== 'string') return false;
  const markdownPatterns = [
    /^#{1,6}\s/m,
    /\*\*.*\*\*/,
    /\*.*\*/,
    /\[.*\]\(.*\)/,
    /^[-*+]\s/m,
    /^\d+\.\s/m,
    /```[\s\S]*?```/,
    /`[^`]+`/,
  ];
  return markdownPatterns.some((pattern) => pattern.test(str));
};

export const isCode = (str: string): boolean => {
  if (!str || typeof str !== 'string') return false;
  const codeKeywords = [
    'function',
    'const ',
    'let ',
    'var ',
    'import ',
    'export ',
    'class ',
    'def ',
    'async ',
    'await ',
  ];
  return (
    str.includes('\n') && codeKeywords.some((keyword) => str.includes(keyword))
  );
};

export const isEndpointsXML = (str: string): boolean => {
  if (!isXMLLike(str)) return false;
  return (
    str.includes('<endpoint>') ||
    str.includes('<endpoints_list_tool_call_response>')
  );
};

export const isEndpointDetailsXML = (str: string): boolean => {
  if (!isXMLLike(str)) return false;
  return str.includes('<endpoint_details_tool_call_response>');
};

export const isFindingsData = (data: unknown): boolean => {
  if (!data || typeof data !== 'object') return false;
  const obj = data as Record<string, unknown>;

  if (Array.isArray(obj.results)) {
    const firstResult = obj.results[0];
    return !!(
      firstResult &&
      typeof firstResult === 'object' &&
      ('findingId' in firstResult ||
        'findingTitle' in firstResult ||
        'severity' in firstResult)
    );
  }

  return !!(
    'findingId' in obj ||
    'findingTitle' in obj ||
    ('severity' in obj && 'category' in obj)
  );
};

export const isFileWriteData = (data: unknown): boolean => {
  if (!data || typeof data !== 'object') return false;
  const obj = data as Record<string, unknown>;
  return !!(obj.filePath && typeof obj.filePath === 'string' && obj.content);
};

export const isFileReadData = (data: unknown): boolean => {
  if (!data || typeof data !== 'object') return false;
  const obj = data as Record<string, unknown>;
  return !!(
    obj.filePath &&
    typeof obj.filePath === 'string' &&
    obj.content &&
    typeof obj.content === 'string'
  );
};

export const isSignalsData = (data: unknown): boolean => {
  if (!data || typeof data !== 'object') return false;
  const obj = data as Record<string, unknown>;

  if (Array.isArray(obj.results)) {
    const firstResult = obj.results[0];
    return !!(
      firstResult &&
      typeof firstResult === 'object' &&
      ('signalId' in firstResult ||
        'signalTitle' in firstResult ||
        'endpointId' in firstResult ||
        ('score' in firstResult && 'rank' in firstResult))
    );
  }

  return false;
};
